import React, { useState, createContext, useContext, type ReactNode } from 'react'
import cx from 'classnames'
import './style.sass'
import { Icon } from '../Icon'

type CollapsibleContextType = {
	visible: string | undefined
	toggleCollapsible: (id: string) => void
}

const CollapsibleContext = createContext<CollapsibleContextType>({
	visible: undefined,
	toggleCollapsible: () => {},
})

type CollapsibleProps = {
	children: ReactNode
	className?: string
	initialVisibleItem?: string
}

export const Collapsible = ({ children, className, initialVisibleItem }: CollapsibleProps) => {
	const [visible, setVisible] = useState<string | undefined>(initialVisibleItem)

	const cs = cx('Collapsible', className)

	const toggleCollapsible = (id: string) => {
		if (visible === id) {
			setVisible(undefined)
		} else {
			setVisible(id)
		}
	}

	return (
		<CollapsibleContext.Provider value={{ visible, toggleCollapsible }}>
			<div className={cs}>{children}</div>
		</CollapsibleContext.Provider>
	)
}

type CollapsibleItemProps = {
	id: string
	title: ReactNode
	className?: string
	children: ReactNode
}

export const CollapsibleItem = ({ id, title, className, children }: CollapsibleItemProps) => {
	const collapsibleContext = useContext(CollapsibleContext)

	const cs = cx('Collapsible__item', className, { 'Collapsible__item--open': collapsibleContext.visible === id })

	const onClick = () => collapsibleContext.toggleCollapsible(id)

	return (
		<div className={cs}>
			<button className='Collapsible__title' onClick={onClick}>
				{title}
				<Icon name='chevron-down' width={18} height={18}></Icon>
			</button>
			<div className='Collapsible__content'>
				<div className='Collapsible__text'>{children}</div>
			</div>
		</div>
	)
}
